<template>
	<div>
		<Breadcrumbs main="Vehicles" title="Add Vehicles" />
			<div class="container-fluid">
				<div class="row">
					<div class="col-sm-12">
						<div class="card">
							<div class="card-body">

								<form @submit.prevent="addVehicle" enctype="multipart/form-data" @hidden="clearForm()">
									<div class="form theme-form">

										<div class="row">
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Title <span class="text-danger">*</span></label>
													<input class="form-control" type="text" placeholder="" v-model="vehicle.title" v-bind:class="{ 'is-invalid': Boolean(errors.title) }" minlength="3" maxlength="200"/>
													<div v-for="(val, index) in errors.title" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Price <span class="text-danger">*</span></label>													
													<input class="form-control" type="text" placeholder="" v-model="vehicle.price" v-bind:class="{ 'is-invalid': Boolean(errors.price) }" minlength="3" maxlength="200" @keypress="decimalsOnly"/>
													<div v-for="(val, index) in errors.price" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">User <span class="text-danger">*</span></label>
													<div class="search-select">
														<select class="form-select" v-model="vehicle.user_id" v-bind:class="{ 'is-invalid': Boolean(errors.user_id) }">
															<option :value="null" disabled>-- Select User --</option>
															<option v-for="user in users" :key="user.id" :value="user.id">{{ user.name }}</option>
														</select>
													</div>
													
												</div>
											</div>
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Category <span class="text-danger">*</span></label>
													
													<select class="form-select" v-model="vehicle.cat_id" v-bind:class="{ 'is-invalid': Boolean(errors.cat_id) }">
														<option :value="null" disabled>-- Select Category --</option>
														<option v-for="cat in categories" :key="cat.id" :value="cat.id">{{ cat.cat_name }}</option>
													</select>
													<div v-for="(val, index) in errors.cat_id" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Brand <span class="text-danger">*</span></label>

													<select class="form-select" v-model="vehicle.brand_id" v-bind:class="{ 'is-invalid': Boolean(errors.brand_id) }" @change="fetchModels()">
														<option :value="null" disabled>-- Select Brand --</option>
														<option v-for="brand in brands" :key="brand.id" :value="brand.id">{{ brand.brand_name }}</option>
													</select>
													<div v-for="(val, index) in errors.brand_id" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Model <span class="text-danger">*</span></label>
													
													<select class="form-select" v-model="vehicle.model_id" v-bind:class="{ 'is-invalid': Boolean(errors.model_id) }">
														<option :value="null" disabled>-- Select Model --</option>
														<option v-for="model in models" :key="model.id" :value="model.id">{{ model.name }}</option>
													</select>
													<div v-for="(val, index) in errors.model_id" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-sm-12">
												<div class="mb-3">
													<label class="control-label">Description <span class="text-danger">*</span></label>

													<textarea class="form-control" type="textarea" placeholder="" rows="4" max-rows="6" v-model="vehicle.description" v-bind:class="{ 'is-invalid': Boolean(errors.description) }"></textarea>
													<div v-for="(val, index) in errors.description" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
										</div>	

										<div class="row">
											<div class="col-sm-12">
												<div class="mb-3">
													<label class="control-label">Location <span class="text-danger">*</span></label>

													<GMapAutocomplete 
														@place_changed="setPlace" class="form-control" 
														placeholder="Search here to pick the required latitude and longitude..."
														:value="vehicle.location">
													</GMapAutocomplete>

													<GMapMap  v-if="vehicle.location"
														:center="center"
														:zoom="18"
														map-style-id="roadmap"
														:options="mapOptions"
														style="width: 100%; height: 30vmin"
														ref="mapRef"
														@click="handleMapClick">
															<GMapMarker 
																:position="marker.position"
																:clickable="true"
																:draggable="true"
																@drag="handleMarkerDrag"
																@click="panToMarker"
															/>
													</GMapMap > 

													<div v-for="(val, index) in errors.location" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Latitude<span class="text-danger">*</span></label>
													
													<input v-model="marker.position.lat" class="form-control" type="text" v-bind:class="{ 'is-invalid': Boolean(errors.latitude) }" minlength="3" maxlength="100" @keypress="decimalsOnly"/>
													<div v-for="(val, index) in errors.latitude" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Longitude <span class="text-danger">*</span></label>

													<input v-model="marker.position.lng" type="text" class="form-control" v-bind:class="{ 'is-invalid': Boolean(errors.longitude) }" minlength="3" maxlength="100" @keypress="decimalsOnly"/>
													<div v-for="(val, index) in errors.longitude" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div>
													
												</div>
											</div>
										</div>

										<div class="row">
											<div class="col-md-10 d-flex">
												<span style="font-size: 16px; font-weight: bold;">Attributes</span>
											</div>

											<div class="row">
												<div class="col-sm-6" v-for="(attr, index) in attributes" :key="attr.id">

													<div class="attr-wrapper" v-if="attr.type==1" :label="attr.name">
														<div class="card"><span class="attr-label">{{ attr.name }}</span>
															<div class="col attr" style="margin-top: 15px;">

																<label for="radio1" v-for="val in attr.values" :key="val.id" :value="val.id + '_' + val.value">
																  <input id="radio1" type="radio" :name="'attr' + index" :value="val.id + '_' + val.value" v-model="vehicle_attributes[attr.type + '_' + attr.id]" />{{ val.value }} &nbsp; 
																	
																</label>
																 <div v-if="attributeErrors[attr.id]" class="invalid-feedback">
																	<p class="mb-0">{{ attributeErrors[attr.id] }}</p>
																</div>
															</div>
														</div>											
													</div>

													<!-- <div class="attr-wrapper" v-if="attr.type==1" :label="attr.name">
														<div class="card"><span class="attr-label">{{ attr.name }}</span>
															<div class="col attr" style="margin-top: 15px;">
																<div class="radio-group" >
																	<input id="radio1" type="radio" v-for="val in attr.values" :key="val.id" :value="val.id + '_' + val.value"  :name="'attr' + index" v-model="vehicle_attributes[attr.type + '_' + attr.id]"/>{{val.value}} &nbsp;
																</div>
															</div>
														</div>	
													</div> -->

													<!-- <b-form-group class="attr-wrapper" v-if="attr.type==1" :label="attr.name">											
														<b-form-radio-group class="card" :name="'attr' + index" v-model="vehicle_attributes[attr.type + '_' + attr.id]">
															<b-form-radio v-for="val in attr.values" :key="val.id" :value="val.id + '_' + val.value">{{val.value}}</b-form-radio>	
														</b-form-radio-group>									
													</b-form-group> -->


													<div class="attr-wrapper attr" v-else-if="attr.type==2" :label="attr.name">
														<b-form-checkbox-group  :name="'attr' + index" v-model="vehicle_attributes[attr.type + '_' + attr.id]" >
															<b-form-checkbox v-for="val in attr.values" :key="val.id" :value="val.id + '_' + val.value">{{val.value}}</b-form-checkbox>
														</b-form-checkbox-group>
														 <div v-if="attributeErrors[attr.id]" class="invalid-feedback">
															<p class="mb-0">{{ attributeErrors[attr.id] }}</p>
														</div>
													</div>

													<div class="attr-wrapper attr" v-else-if="attr.type==3" :label="attr.name">
														<input :name="'attr' + index" v-model="vehicle_attributes[attr.type + '_' + attr.id]"/>
														<div v-if="attributeErrors[attr.id]" class="invalid-feedback">
															<p class="mb-0">{{ attributeErrors[attr.id] }}</p>
														</div>
													</div>

													<div class="attr-wrapper" v-else-if="attr.type==4" :label="attr.name">
														<textarea :name="'attr' + index" rows="3" max-rows="6" v-model="vehicle_attributes[attr.type + '_' + attr.id]"></textarea>
														<div v-if="attributeErrors[attr.id]" class="invalid-feedback">
															<p class="mb-0">{{ attributeErrors[attr.id] }}</p>
														</div>
													</div>

													<div class="attr-wrapper" v-if="attr.type==5" :label="attr.name">
														<b-form-input v-model="grid_text" class="mb-3"></b-form-input>
														<b-form-radio-group class="button-radio" :name="'attr' + index" button-variant="outline-primary" buttons v-model="vehicle_attributes[attr.type + '_' + attr.id]">
															<b-form-radio v-for="val in attr.values" :key="val.id" :value="val.id + '_' + val.value"  @change="setGridText($event)">{{val.value}}</b-form-radio>	
														</b-form-radio-group>	
														 <div v-if="attributeErrors[attr.id]" class="invalid-feedback">
															<p class="mb-0">{{ attributeErrors[attr.id] }}</p>
														</div>							
													</div>
												</div>
											</div>
											
										</div>

										<div class="row">
											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Images <span class="text-danger">*</span></label>
													
													<div class="row" v-for="(input, index) in inputs" :key="index">    
														<div class="col-md-6 form-group">    

															<input ref="fileinput" type="file" @change="setFile($event, index)" accept="image/*" class="form-control"  v-bind:class="{ 'is-invalid': Boolean(errors.image) }"/>
															<span>
																<i class="fa fa-minus-circle text-danger" @click="remove(index)" v-show="index || ( !index && inputs.length > 1)"></i>
																<i class="fa fa-plus-circle text-success" @click="add()" v-show="index == inputs.length-1"></i>
															</span>
														</div>
														<div class="col" md="6">
															<img class="image-preview" v-bind:src="input.preview_image">
														</div>
													</div>

												</div>
											</div>

											<div class="col-sm-6">
												<div class="mb-3">
													<label class="control-label">Video</label>
													<input class="form-control" type="file" placeholder="">
													<!-- <b-form-input v-model="user.email" v-bind:class="{ 'is-invalid': Boolean(errors.email) }"></b-form-input>
													<div v-for="(val, index) in errors.email" :key="index" class="invalid-feedback">
														<p class="mb-0">{{ val }}</p>
													</div> -->
												</div>
											</div>
										</div>

										<div class="row">
											
										</div>
								
										<div class="col-sm-6">
											<button class="btn btn-primary me-3" type="submit">Add</button>
											<a class="btn btn-light" >Reset</a>
											<!-- <button type="submit" class="mr-3" variant="primary">Add</button>
											<button class="" variant="light">Reset</button> -->
										</div>
									
									</div>
								</form>

							</div>
						</div>
					</div>
				</div>
			</div>
 
   </div>
</template>


<script>
import '@/assets/css/custom.css';
import {ref, onMounted} from "vue";

const address = ref('');

	export default {
		name: "AddVehicle",
		setup() {
			let mapRef = ref(null);
			// onMounted

		},
		
		data() {
			
			return {
				vehicle: {
					title: '',
					brand_id: null,
					model_id: null,
					cat_id: null,
					user_id: null,
					description: '',
					price: null,
					location: '',
					latitude: null,
					longitude: null,
					video: '',
					attribute_ids: [],
					attribute_value_ids: [],
					attribute_values: [],
				},

				mapRef:'',
				address: "",
				
				marker: { position: { lat: null, lng: null } },
				center: { lat: null, lng: null },
				current_place: null,

				mapOptions: {
					disableDefaultUI: true,
				},

				users: {},
				categories: {},
				brands: {},
				models: {},
				attributes: [],
				inputs: [
					{value: null, preview_image: null, image: null}
				],
				vehicle_attributes: {},
				grid_text: null,
				images: [],
				keyword: '',
				visible: false,
				token: "",
				errors: {},
				 attributeErrors: {},

			};
		},
		mounted() {
			// this.$refs.address.focus();
			this.fetchUsers();
		},

		created() {
			
			this.fetchCategories();
			this.fetchBrands();
			this.fetchAttributes();
			// this.fetchModels();
			
		},

		methods: {

			add() {
				this.inputs.push({ value: null });
			},

			validateAttributes() {
				this.attributeErrors = {}; 

				this.attributes.forEach(attr => {
					const value = this.vehicle_attributes[attr.type + '_' + attr.id];
					
					if (!value || (Array.isArray(value) && value.length === 0)) {
						this.attributeErrors[attr.id] = `Please select at least one option for ${attr.name}.`;
						console.log(this.attributeErrors);
					}
				});

				return Object.keys(this.attributeErrors).length === 0;
			},


			remove(index) {
				this.inputs.splice(index, 1);
				this.images.splice(index, 1);
			}, 

			setFile(e, index) {
				this.images.push(e.target.files[0]);
				this.inputs[index].image = e.target.files[0];
				this.inputs[index].preview_image = URL.createObjectURL(e.target.files[0]);
			},

			geolocate() {
		      navigator.geolocation.getCurrentPosition((position) => {
		         this.marker.position = {
		           lat: position.coords.latitude,
		           lng: position.coords.longitude,
		         };
		         this.panToMarker();
      		});
    		},

		   
			handleMarkerDrag(e) {
      			this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
    		},

    		panToMarker() {
				this.$refs.mapRef.panTo(this.marker.position);
    		},

    		handleMapClick(e) {
				this.marker.position = { lat: e.latLng.lat(), lng: e.latLng.lng() };
				console.log(e);
    		},	 

		 	setPlace(place) {
		    	this.current_place = place;
		    	if(this.current_place) {
		    		const marker = {
			    		lat: this.current_place.geometry.location.lat(),
			    		lng: this.current_place.geometry.location.lng(),
			    	};
			    	this.center = marker;
			    	this.marker.position = marker;
			    	this.vehicle.location = place.formatted_address;
					this.vehicle.latitude = marker.lat;
	    			this.vehicle.longitude = marker.lng;
		    	}
		   },

			decimalsOnly(event) {
		      let keyCode = event.keyCode;
		      if (keyCode >= 48 || keyCode <= 57 || keyCode == 46 ) {
		      	return;
		      } else {
		        event.preventDefault();
		      }
		    },
		    alphaSpacesOnly(event) {
		    	let keyCode = event.keyCode;
			    if ((keyCode >= 65 && keyCode <= 90) || 
			    	(keyCode >= 97 && keyCode <= 122) ||			    	
			    	(keyCode == 32)) {
			        return;
			    } else {
			    	event.preventDefault();
			    }
		    },
		   
			getToken() {
                if (localStorage.getItem('slo_admin')) {
                    var slo_admin =  JSON.parse(localStorage.getItem('slo_admin')); 
                    
                    if(slo_admin.token) {

                        this.token = slo_admin.token;
                        this.user = slo_admin;

                    } else {
                        this.$swal("", "Failed to fetch token, please login again", "error");
                        this.$router.push({ name: "Login" });
                    }

                } else {
                    this.$swal("", "Session expired, please login again", "error");
                    this.$router.push({ name: "Login" });
                }
            },

			fetchCategories() {
				let url = "/api/admin/vehicles/category";			
				this.getToken();
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.categories = responseData.data;
					})
					.catch((err) => console.log(err));
			},

			fetchBrands() {
				let url = "/api/admin/vehicles/brands";				

				this.getToken();
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.brands = responseData.data;
					})
					.catch((err) => console.log(err));
			},

			fetchModels() {
				
				let url = "/api/admin/vehicles/models?brand_id=" + this.vehicle.brand_id;			

				this.getToken();
				this.$axios
					.get(url, { headers: { Authorization: "Bearer " + this.token } })
					.then((res) => {
						var responseData = res.data;
						this.models = responseData.data;
						console.log(this.models);
					})
					.catch((err) => console.log(err));
			},

			
			fetchUsers() {
				let url = "/api/admin/users?limit=0&keyword=" + this.keyword;
				this.getToken();
				this.$axios
					.get(url, {
						headers: { Authorization: "Bearer " + this.token },
					})
					.then((res) => {
						var responseData = res.data.data;
						this.users = responseData.data;
						this.items = [];

						for(var i = 0; i < responseData.data.length; i++) {
							this.items.push(responseData.data[i].name + '|' + responseData.data[i].phone_number )
						}
						console.log(this.users);
						this.visible = true;
						// this.accessory.user_id = null;
					})
					.catch((err) => console.log(err));
			},

			fetchAttributes() {
				let url = "/api/admin/vehicles/attributes";
				this.$axios
					.get(url, {
						headers: { Authorization: "Bearer " + this.token },
					})
					.then((res) => {
						var responseData = res.data.data;
						this.attributes = responseData;
						console.log(responseData);
						
					})
					.catch((err) => console.log(err));
			},

			setUser() {
				this.keyword = event.target.options[event.target.options.selectedIndex].label;
				this.visible = false;
			},

			setVideo(event) {
				this.vehicle.video = event.target.files[0];
			},

			setGridText(event) {
				
				let key_array = event.split("_");
				this.grid_text = key_array[1];

			},

			addVehicle() {

				if (!this.validateAttributes()) {
							return;
				}
				this.getToken();
				let formData = new FormData();
				formData.append("title", this.vehicle.title);
				formData.append("price", this.vehicle.price);
				formData.append("cat_id", this.vehicle.cat_id);
				formData.append("user_id", this.vehicle.user_id);
				formData.append("brand_id", this.vehicle.brand_id);
				formData.append("model_id", this.vehicle.model_id);
				formData.append("description", this.vehicle.description);
				formData.append("location", this.vehicle.location);
				// formData.append("latitude", this.marker.position.lat);
				// formData.append("longitude", this.marker.position.lng);
				formData.append("latitude", this.marker.position.lat);
				formData.append("longitude", this.marker.position.lng);
				formData.append("video", this.vehicle.video);
			

				for(var key of Object.keys(this.vehicle_attributes)) {

					let key_array = key.split("_");	      	
					
					if(key_array[0] == 3 || key_array[0] == 4) { 
						this.vehicle.attribute_ids.push(key_array[1]);
						this.vehicle.attribute_value_ids.push('0');
						this.vehicle.attribute_values.push(this.vehicle_attributes[key]);

					} else if(key_array[0] == 5) {
						
						this.vehicle.attribute_ids.push(key_array[1]);
						this.vehicle.attribute_value_ids.push('0');
						this.vehicle.attribute_values.push(this.grid_text);
					} else {
						
						if(key_array[0] == 2) {
							let chk_array = this.vehicle_attributes[key];
							for(var i = 0; i < chk_array.length; i++) {
								this.vehicle.attribute_ids.push(key_array[1]);
								let value_array = chk_array[i].split('_');
								this.vehicle.attribute_value_ids.push(value_array[0]);
								this.vehicle.attribute_values.push(value_array[1]);
							}
						} else {
							let array = this.vehicle_attributes[key].split("_");
							this.vehicle.attribute_value_ids.push(array[0]);
							this.vehicle.attribute_values.push(array[1]);
							this.vehicle.attribute_ids.push(key_array[1]);
						}
					}	         	
				}

	         console.log('attribute_ids', this.vehicle.attribute_ids);
	         console.log('attribute_value_ids', this.vehicle.attribute_value_ids);
	         console.log('attribute_values', this.vehicle.attribute_values);


	         formData.append('attribute_value_ids', JSON.stringify(this.vehicle.attribute_value_ids));
	         formData.append('attribute_values', JSON.stringify(this.vehicle.attribute_values));
	         formData.append('attribute_ids', JSON.stringify(this.vehicle.attribute_ids));

	        

				for(var j = 0; j < this.images.length; j++) {
				  	let file = this.images[j];
				   formData.append('images[' + j + ']', file);
				}

				const config = {
					headers: {
						"content-type": "multipart/form-data",
						Authorization: "Bearer " + this.token,
					},
				};

				let url;
				url = "/api/admin/vehicles/add";

				this.$axios
					.post(url, formData, config)
					.then((response) => {
						if (response.data.status) {
							this.$swal("", response.data.message, "success");
						} else {
							this.$swal("", response.data.message, "error");
						}
						this.clearForm();
					})
					.catch((error) => {
						this.errors = {};
						if (error.response) {
							if (error.response.data.message) {
								console.log(error.response.data);
								this.errors = error.response.data.message;
								console.log(this.errors);
								
							} else {
								this.$swal("", "Something went wrong", "error");
							}
						} else {
							this.$swal("", "Something went wrong", "error");
						}
					});
			},

			clearForm() {
				this.fetchCategories();
				this.fetchBrands();
				this.fetchAttributes();
				this.vehicle.title = "";
				this.vehicle.description = "";
				this.vehicle.brand_id = null;
				this.vehicle.model_id = null;
				this.vehicle.cat_id = null;
				this.vehicle.user_id = null;
				this.vehicle.price = null;
				this.vehicle.location = '';
				this.marker.position.lat = null;
				this.marker.position.lng = null;
				this.vehicle.video = null,
				this.inputs = [{value: null, preview_image: null}];
				this.images = [];
				this.vehicle_attributes = {};
				this.errors = {};
				this.keyword = '';
			},
		},
	};
</script>
<style>
.invalid-feedback {
    display: block !important;
    color: red; /* Optional: for better visibility */
}</style>
